import axios from "axios";

// Movido de features/franquia quando Instituição precisou do mesmo lookup —
// extrair na segunda ocorrência real, não na primeira.
export interface ViaCepResponse {
  erro?: boolean;
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
}

// ViaCEP é um serviço público de terceiro, sem autenticação — usa axios cru,
// nunca o `api` (que injeta Bearer e aponta pro gateway Silpi).
export async function buscarCep(cep: string): Promise<ViaCepResponse> {
  const digits = cep.replace(/\D/g, "");
  const { data } = await axios.get<ViaCepResponse>(`https://viacep.com.br/ws/${digits}/json`);
  return data;
}
